import { ACTION } from '@/store/ACTION';

class SetFreeSpinsData {
  protected allowed(): boolean {
    return Boolean(this.store.promo.isFreeSpinsTournament);
  }

  execution(): void {
    if (!this.allowed()) return;

    promoApp.eventEmitter.emit(ACTION.SET_FREESPIN_DATA, {
      tournamentFreeSpin: this.store.promo.tournamentFreeSpin,
      currency: this.store.currency,
      currencyDecimal: this.store.currencyDecimal
    });
  }

  get store() {
    return game.store;
  }
}

export { SetFreeSpinsData };
